import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { API_ENDPOINT, HEADER_TOKEN } from "../../constants/constants";
import { toast } from "react-toastify";
import { isLoggedIn } from "../../utilities/utility";
import AnswerBox from "./live/widgets/answerBox";
import appLogo from "../../assets/svgs/logo.svg";
import aprofile from "../../assets/images/aprofile.png";
import Header from "../dashboard/header";
import PreviewAnswerBox from "./live/widgets/PreviewAnswerBox";
import { io } from "socket.io-client";
import AssLogo from "../widgets/assLogo";
import CustomCircularP from "../widgets/customCircularP";
import IntroLogo from "../widgets/introLogo";

const Response = React.forwardRef((props, ref) => {
  const { showDownload, setShowDownload } = props;
  const optionsI = ["A", "B", "C", "D", "E", "F"];
  const [a, setA] = useState({});
  const [score, setScore] = useState(0);
  const [tscore, setTScore] = useState(0);
  const [numAttempted, setNumAttempted] = useState(0);
  const [numTopics, setNumTopics] = useState(0);
  const [failedM, setFailedM] = useState("");
  const [hideWaitTrainer, setHideWaitTrainer] = useState(false);
  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");
  const linkCode = keysUrl[4];
  const name = decodeURIComponent(keysUrl[6]);
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    const newSocket = io(API_ENDPOINT, { transports: ["websocket"] });
    setSocket(newSocket);
    return () => newSocket.close();
  }, [setSocket]);

  useEffect(() => {
    if (socket !== null) {
      socket.on("end-" + linkCode, (m) => {
        console.log("Socket works");
        if (hideWaitTrainer === false) loadResult();
      });
    }
  }, [socket]);

  
  useEffect(() => {
    checkStatus();
    if (hideWaitTrainer === false) loadResult();
  }, []);
  // Function to check the status
  async function checkStatus() {
    try {
      axios
        .post(
          API_ENDPOINT + "assessment-details/",
          { linkCode },
          HEADER_TOKEN
        )
        .then((res) => {
          let d = res.data;
          if (d.success) {
            let A = d.message;
            setNumTopics(A.numTopics);
            if (A.status === "completed") {
              //window.location.reload(); // Reload the page if status is "completed"
              //clearInterval(statusCheckInterval); // Stop the timer
              if (hideWaitTrainer === false) loadResult();
            }
          }
        });
    } catch (error) {
      console.error("Error fetching status:", error);
    }
  }

  // Poll the status every 5 seconds
  //let statusCheckInterval = setInterval(checkStatus, 10000);
  function isAssessmentOver(assessment) {
    let mbool = true;
    if (assessment.createdOn !== undefined) {
      var createdOn = new Date(assessment.createdOn);
      var now = new Date();
      createdOn.setMinutes(createdOn.getMinutes() + assessment.duration);
      mbool = now >= createdOn;
    }

    return assessment.status === "completed" || mbool;
  }
  function loadResult() {
    axios
      .post(API_ENDPOINT + "assessment-result", { linkCode, name })
      .then((res) => {
        let d = res.data;
        console.log(d);
        if (d.success) {
          let an = d.message;
          setA(an);

          if (
            an.config.showAnswer === false &&
            an.config.previewCorrect === false &&
            an.config.previewStatus === false
          ) {
            setHideWaitTrainer(true);
          }

          if (isAssessmentOver(an) && an.config.allowReport) {
            setShowDownload(true);
          } else {
            setShowDownload(false);
          }
          let t = an.answers.length;
          let s = an.answers.filter((c) => isCorrect(c.options, c.response));
          let sc = s.length;

          setScore(sc);
          setTScore(t);
          setNumAttempted(an.numAttempted);
        } else {
          setFailedM(d.message);
        }
      });
  }
  function isCorrect(os, r) {
    let ind = os.findIndex((o) => o.isCorrect);
    return optionsI[ind] === r;
  }
  return (
    <div ref={ref}>      
        {Object.keys(a).length > 0  ? (
          isAssessmentOver(a) && (hideWaitTrainer === false || isLoggedIn() )  ? (
            a.config.previewCorrect || isLoggedIn() ?(
              <div className="page-bg">
                <div className="top-nav">
                    <AssLogo/>
                    <div className="test-title">{a.title}</div>
                    <div className="user-score">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <g clipPath="url(#clip0_772_1058)">
                          <path d="M59.7488 10.2513C53.1381 3.64068 44.3488 0 35 0C25.6512 0 16.8619 3.64068 10.2512 10.2513C3.64068 16.8619 0 25.6512 0 35C0 44.3488 3.64068 53.1381 10.2512 59.7487C16.8619 66.3593 25.6512 70 35 70C44.3488 70 53.1381 66.3593 59.7488 59.7487C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7488 10.2513ZM35 65.8984C25.8578 65.8984 17.6317 61.906 11.9695 55.5747C15.4797 46.2686 24.4655 39.6484 35 39.6484C28.2043 39.6484 22.6953 34.1395 22.6953 27.3438C22.6953 20.548 28.2043 15.0391 35 15.0391C41.7957 15.0391 47.3047 20.548 47.3047 27.3438C47.3047 34.1395 41.7957 39.6484 35 39.6484C45.5345 39.6484 54.5203 46.2686 58.0305 55.5747C52.3683 61.906 44.1422 65.8984 35 65.8984Z" fill="#444444"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_772_1058">
                            <rect width="70" height="70" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                        {/* <img src="./images/pro.png" alt="User"> */}
                        <div className="user-info">
                            <span>{a.name}</span>
                            <span className="score-top">Your Score : {Math.round((parseInt(score) / parseInt(tscore)) * 100)}%</span>
                        </div>
                    </div>
                </div>

                <div className="result-container">
                    <div className="quiz-header">
                        <p>Answer Sheet</p>
                        <p>You answered {parseInt(score)} out of {parseInt(tscore)} questions correctly</p>
                    </div>
                    {a.answers.map((b) => (
                      <AnswerBox assessment={a} answer={b} />
                    ))}
                </div>
            </div>
            ) : (
              <div className="page-bg">
    <div className="top-nav">
    <AssLogo/>
        <div className="test-title">{a.title}</div>
        <div className="user-score">
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g clipPath="url(#clip0_772_1058)">
              <path d="M59.7488 10.2513C53.1381 3.64068 44.3488 0 35 0C25.6512 0 16.8619 3.64068 10.2512 10.2513C3.64068 16.8619 0 25.6512 0 35C0 44.3488 3.64068 53.1381 10.2512 59.7487C16.8619 66.3593 25.6512 70 35 70C44.3488 70 53.1381 66.3593 59.7488 59.7487C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7488 10.2513ZM35 65.8984C25.8578 65.8984 17.6317 61.906 11.9695 55.5747C15.4797 46.2686 24.4655 39.6484 35 39.6484C28.2043 39.6484 22.6953 34.1395 22.6953 27.3438C22.6953 20.548 28.2043 15.0391 35 15.0391C41.7957 15.0391 47.3047 20.548 47.3047 27.3438C47.3047 34.1395 41.7957 39.6484 35 39.6484C45.5345 39.6484 54.5203 46.2686 58.0305 55.5747C52.3683 61.906 44.1422 65.8984 35 65.8984Z" fill="#444444"/>
            </g>
            <defs>
              <clipPath id="clip0_772_1058">
                <rect width="70" height="70" fill="white"/>
              </clipPath>
            </defs>
          </svg>
            {/* <img src="./images/pro.png" alt="User"> */}
            <div className="user-info">
                <span>{a.name}</span>
                <span className="score-top">Your Score : {Math.round((parseInt(score) / parseInt(tscore)) * 100)}%</span>
            </div>
        </div>
    </div>

    <div className="result-container">
        <div className="quiz-header">
            <p>Answer Sheet</p>
            <p>You answered {parseInt(score)} out of {parseInt(tscore)} questions correctly</p>
        </div>
            {a.answers.map((b) => (
                      <PreviewAnswerBox assessment={a} answer={b} />
                    ))}
    </div>
</div>
            )
          ) : (
            <div ref={ref} className="d-flex justify-content-center align-items-center main-bg container-fluid">
            <IntroLogo/>
            <div className="info-container">
        <div className="score text-center">{a.title}</div>
        <div className="profile-img"><svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g clipPath="url(#clip0_772_1058)">
              <path d="M59.7488 10.2513C53.1381 3.64068 44.3488 0 35 0C25.6512 0 16.8619 3.64068 10.2512 10.2513C3.64068 16.8619 0 25.6512 0 35C0 44.3488 3.64068 53.1381 10.2512 59.7487C16.8619 66.3593 25.6512 70 35 70C44.3488 70 53.1381 66.3593 59.7488 59.7487C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7488 10.2513ZM35 65.8984C25.8578 65.8984 17.6317 61.906 11.9695 55.5747C15.4797 46.2686 24.4655 39.6484 35 39.6484C28.2043 39.6484 22.6953 34.1395 22.6953 27.3438C22.6953 20.548 28.2043 15.0391 35 15.0391C41.7957 15.0391 47.3047 20.548 47.3047 27.3438C47.3047 34.1395 41.7957 39.6484 35 39.6484C45.5345 39.6484 54.5203 46.2686 58.0305 55.5747C52.3683 61.906 44.1422 65.8984 35 65.8984Z" fill="#444444"/>
            </g>
            <defs>
              <clipPath id="clip0_772_1058">
                <rect width="70" height="70" fill="white"/>
              </clipPath>
            </defs>
          </svg></div>
        <div className="name text-center mt-2">{a.name}</div>
        <div className="score text-center">Your Score: {Math.round((parseInt(score) / parseInt(tscore)) * 100)}%</div>
        <div className="info text-center">You answered {parseInt(score)} out of {parseInt(tscore)} questions correctly</div>
        <div className="assessment-info d-flex justify-content-center">
            <div className="d-flex me-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M17.5001 5.49996H15.8334V13H5.00008V14.6666C5.00008 15.125 5.37508 15.5 5.83341 15.5H15.0001L18.3334 18.8333V6.33329C18.3334 5.87496 17.9584 5.49996 17.5001 5.49996ZM14.1667 10.5V2.99996C14.1667 2.54163 13.7917 2.16663 13.3334 2.16663H2.50008C2.04175 2.16663 1.66675 2.54163 1.66675 2.99996V14.6666L5.00008 11.3333H13.3334C13.7917 11.3333 14.1667 10.9583 14.1667 10.5Z" fill="#777777"/>
                  </svg>
                  <span className="ms-1">{parseInt(tscore)} Questions</span>
            </div>
            <div className="d-flex me-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M16.6667 5.50004H10.0001L8.33341 3.83337H3.33341C2.41675 3.83337 1.67508 4.58337 1.67508 5.50004L1.66675 15.5C1.66675 16.4167 2.41675 17.1667 3.33341 17.1667H16.6667C17.5834 17.1667 18.3334 16.4167 18.3334 15.5V7.16671C18.3334 6.25004 17.5834 5.50004 16.6667 5.50004ZM11.6667 13.8334H5.00008V12.1667H11.6667V13.8334ZM15.0001 10.5H5.00008V8.83337H15.0001V10.5Z" fill="#777777"/>
                  </svg>
                  <span className="ms-1">{numTopics} Topics</span>
            </div>
            <div className="d-flex me-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M9.99175 2.16663C5.39175 2.16663 1.66675 5.89996 1.66675 10.5C1.66675 15.1 5.39175 18.8333 9.99175 18.8333C14.6001 18.8333 18.3334 15.1 18.3334 10.5C18.3334 5.89996 14.6001 2.16663 9.99175 2.16663ZM10.0001 17.1666C6.31675 17.1666 3.33341 14.1833 3.33341 10.5C3.33341 6.81663 6.31675 3.83329 10.0001 3.83329C13.6834 3.83329 16.6667 6.81663 16.6667 10.5C16.6667 14.1833 13.6834 17.1666 10.0001 17.1666Z" fill="#777777"/>
                    <path d="M10.4167 6.33337H9.16675V11.3334L13.5417 13.9584L14.1667 12.9334L10.4167 10.7084V6.33337Z" fill="#777777"/>
                  </svg>
                  <span className="ms-1">{a.duration} Minutes</span>
            </div>
        </div>
        {hideWaitTrainer === false ? (
                <div className="info text-center mt-2">{`Please wait for the trainer to end the assessment for a detailed report.`}</div>
              ) : (
                ""
              )}
        {/* <div className="d-flex justify-content-center">
            <button className="details-btn">View Detailed Report</button>
        </div> */}
    </div>
    </div>
          )
        ) : (
          <div>{failedM === "" ? <CustomCircularP/> : failedM}</div>
        )}
    </div>
  );
});
export default Response;
